export const getElapsedTime = (createdAt?: Date | string, finishedAt?: Date | string) => {
    if (!createdAt) {
        return '';
    }

    const created = new Date(createdAt).getTime();
    const finished = finishedAt ? new Date(finishedAt).getTime() : Date.now();
    const diff = finished - created;
    const seconds = (diff / 1000) % 60;
    return `${seconds.toFixed(1)}s`;
};
